import axios from "axios";
import { EncryptionService } from "../services/encryption.service";
import { getFromStorage } from "../services/localstorage.service";
import { errorNotify } from "../services/toast.notification";
import moment from 'moment'
import jalali_moment from 'jalali-moment';



const apiPath = 'http://www.webapi.pws.ir/api';
//const apiPath = 'http://192.168.1.20:8087/api';
//const apiPath = 'http://192.168.1.103:8181/api';
//const apiPath = 'http://172.20.10.2:8181/api'; 
//const apiPath = 'http://192.168.1.35:8181/api';
//const myURL = "http://192.168.1.103:8086";
//const myURL = "http://91.92.184.255:8065";


interface loginCredential {
    userName: string;
    password: string;
}

interface manualPay {
    requestId: number;
    labId: number;
    billId: number;
    userId?: number;
    bankAccount: number;
    payType: number;
    title: string;
    payAmount: number
    description: string;
}

const checkToken = () => {

    let jwt = getFromStorage("jwt");

    if (jwt === undefined || jwt === null) {
        errorNotify('مدت زمان استفاده از توکن امنیتی منقضی شده است و نیاز است مجددا به سیستم وارد شوید', undefined, 5000)
        Promise.reject(new Error('مدت زمان استفاده از توکن امنیتی منقضی شده است و نیاز است مجددا به سیستم وارد شوید'));
    }

    return {
        headers: {
            'authorization': 'Bearer ' + jwt,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    };

}

const generateAuthToken = async () => {

    let enc = new EncryptionService();
    let URL = apiPath + '/v1/auth/auth';
    let payload = {
        userName: 'React',
        password: enc.encryptUsingAES256()
    }

    let res = await axios.post(URL, payload);
    return res;

}

const labuserLogin = async ({ userName, password }: loginCredential) => {

    let URL = apiPath + '/labLogin';
    let payload = {
        username: userName,
        password: password
    }

    let res = await axios.post(URL, payload, checkToken());
    return res;

}

const parsiuserLogin = async ({ userName, password }: loginCredential) => {

    let URL = apiPath + '/parsiclogin';
    let payload = {
        UserName: userName,
        Password: password
    }

    let res = await axios.post(URL, payload, checkToken());
    return res;

}

const updateLabUserPassword = async (labId: number, password: String) => {

    let res = await axios.post(apiPath + '/labLogin/updatePassword', {
        labId,
        username: undefined,
        password,
    }, checkToken());

    return res;
}

const forgetPassword = async (username: String) => {

    let res = await axios.post(apiPath + '/labLogin/sendPassword', {
        username
    }, checkToken());

    return res;
}

const getParsicUser = async () => {

    let res = await axios.get(apiPath + '/parsicLogin', checkToken());
    return res;
}



// str_WebSiteAddress
const getLabList = async (labId?: number) => {

    let res = await axios.get(apiPath + '/lab', checkToken());
    //res.data.str_WebSiteAddress;
    console.log(res);
    return res;
}

const getLabListWithColumnClass = async (labId?: number) => {

    let res = await axios.get(apiPath + '/lab', checkToken());
    //res.data.str_WebSiteAddress;
    console.log(res);
    let newList: any[] = [];
    res.data.data.map((item: any) => {
        item.str_ServiceURL ? newList.push('full-row') : newList.push('empty-row')
    });
    const result = res.data.data.map((o: any, i: any) => ({ ...o, columnClass: newList[i] }));
    console.log("lab list new:" + result[0].columnClass);
    return result;
}


const generateOTPForNewCustomerRegisteration = async (mobileNumber: string, labName: string, email: string) => {

    let res = await axios.post(apiPath + '/otpCode', {
        mobileNumber,
        labName,
        email,
    }, checkToken());

    return res;
}

const newCustomerRegisteration = async (data: any) => {
    console.log("data is", JSON.stringify(data))
    let res = await axios.post(apiPath + '/installRequest',
        data
        , checkToken());

    return res;
}


const getState = async () => {

    let res = await axios.get(apiPath + '/lab/state', checkToken());

    return res;
}




const getMachineList = async (machineId?: number) => {

    let res = await axios.get(apiPath + '/machines' + (machineId ? '?machineId=' + machineId : ''), checkToken());

    return res;
}

const InsertMachineDefination = async (machineName: string, machineCode: string, machineBase64: string, installationType: number, connectionType: number, description: string) => {

    let res = await axios.post(apiPath + '/machines', {
        machineName,
        machineCode,
        machineBase64,
        installationType,
        connectionType,
        description
    }, checkToken());

    return res;
}

const updateMachineDefination = async (machineId: number, machineName: string, machineCode: string, machineBase64: string, installationType: number, connectionType: number, description: string) => {

    let res = await axios.put(apiPath + '/machines', {
        machineId,
        machineName,
        machineCode,
        machineBase64,
        installationType,
        connectionType,
        description
    }, checkToken());

    return res;
}

const getMachineNote = async (machineId: number) => {

    let res = await axios.get(apiPath + '/machineNote?machineId=' + machineId, checkToken());

    return res;
}

const InsertMachineNote = async (machineId: number, userId: number, comment: string) => {

    let res = await axios.post(apiPath + '/machineNote', [
        {
            noteId: 0,
            machineId,
            userId,
            comment,
            isImportant: false,
            isDelete: false
        }
    ], checkToken());

    return res;
}

const getMachineDocumentFile = async (machineId: number) => {

    let res = await axios.get(apiPath + '/machineFiles?machineId=' + machineId, checkToken());

    return res;
}

const getAnSpecificMachineDocumentFile = async (fileId: number) => {

    let res = await axios.get(apiPath + '/machineFiles/MachineFile?fileId=' + fileId, checkToken());

    return res;
}


const InsertMachineDocumentFile = async (machineId: number, userId: number, base64File: string, fileName: string, fileExtension: string) => {

    let res = await axios.post(apiPath + '/machineFiles', [
        {
            fileId: 0,
            machineId,
            userId,
            base64File,
            fileName,
            fileExtension,
            isImportant: false,
            isDelete: false
        }
    ], checkToken());

    return res;
}




const getBankAccount = async () => {

    let res = await axios.get(apiPath + '/bankAccount', checkToken());

    return res;
}

const getOnlinePaymentGateway = async () => {

    let res = await axios.get(apiPath + '/onlinePaymentInfo', checkToken());

    return res;
}




const getMachineInstallRequestList = async (filterItem: any) => {

    //var Path = "http://192.168.1.20:8074/api"

    let res = await axios.get
        (apiPath + '/machineRequest?labId=' + (filterItem.labId ? filterItem.labId : 0) + '&dateFrom=' + (filterItem.dateFrom ? filterItem.dateFrom : '') + '&dateTo=' + (filterItem.dateTo ? filterItem.dateTo : '') + '&searchMode=' + (filterItem.searchMode ? filterItem.searchMode : 0) + '&status=' + ((filterItem.status != undefined) ? filterItem.status : -1)
            + '&machineId=' + ((filterItem.machineId != undefined) ? filterItem.machineId : -1) + '&installer=' + ((filterItem.installer != undefined) ? filterItem.installer : -1), checkToken());

    return res;
}

const insertMachineInstallRequestList = async (machineId: number, labId: number, mobile: string, orderDesc: string) => {

    let res = await axios.post(apiPath + '/machineRequest', {
        machineId,
        labId,
        mobile,
        orderDesc
    }, checkToken());

    return res;
}

const getMachineInstallBill = async (requestid?: number, billId?: number) => {
    //billId = 1675;
    let res = await axios.get(apiPath + '/labBill?requestId=' + requestid + '&billId=' + billId, checkToken());

    return res;
}

const machineInstallManualPay = async ({ requestId, labId, billId, userId, bankAccount, payType, title, payAmount, description }: manualPay) => {

    let res = await axios.post(apiPath + '/LabPay', {
        requestId,
        labId,
        billId,
        userId,
        bankAccount,
        payType,
        title,
        payAmount,
        description
    }, checkToken());

    return res;
}

const AssignInstallerForMachineInstallRequest = async (requestId: number, userId: number, installerId?: number) => {

    let res = await axios.post(apiPath + '/machineRequest/AssignInstaller', {
        requestId,
        userId,
        installerId
    }, checkToken());

    return res;
}

const finilizeMachineInstallRequest = async (requestId: number, labId: number, installerId?: number) => {

    //var Path = "http://192.168.1.20:8074/api"

    let res = await axios.post(apiPath + '/machineRequest/InstallerApprove', {
        requestId,
        labId,
        installerId
    }, checkToken());

    return res;
}

const generateOnlineBillLink = async (requestId: number, labId: number, guid: string, amount: number) => {

    let res = await axios.post(apiPath + '/payRequestBank', {
        requestId,
        labId,
        guid,
        amount
    }, checkToken());

    return res;
}

const billSingularPay = async ({ requestId, labId, billId, userId, bankAccount, payType, title, payAmount, description }: manualPay) => {

    let res = await axios.post(apiPath + '/LabPay/singularPay', {
        requestId,
        labId,
        billId,
        userId,
        bankAccount,
        payType,
        title,
        payAmount,
        description
    }, checkToken());

    return res;
}

const generateSingularBill = async (labId: number, billType: number, title: string, description: String, amount: number) => {

    let res = await axios.post(apiPath + '/labBill/singularBill', {
        labId,
        billType,
        title,
        description,
        amount
    }, checkToken());

    return res;
}




const getFinancialbalance = async (labId?: number, dateFrom: any = undefined, dateTo: any = undefined) => {
    let fromdate = '';
    let toDate = '';

    if (dateFrom != undefined) {
        fromdate = jalali_moment.from(dateFrom, 'fa', 'YYYY-M-D')
            .format('YYYY-M-D');
    }
    if (dateTo != undefined) {
        toDate = jalali_moment.from(dateTo, 'fa', 'YYYY-M-D')
            .format('YYYY-M-D');
    }

    let res = await axios.get(apiPath + '/payAndBill?labId=' + labId + '&dateFrom=' + (fromdate ? fromdate : '') + '&dateTo=' + (toDate ? toDate : '')
        , checkToken());

    return res;
}

const getlabtaxInfo = async (labId?: number) => {

    let res = await axios.get(apiPath + '/taxInfo/taxInfo?labId=' + labId, checkToken());

    return res;
}

const updateTaxInfo = async (labId?: number, economicCode?: string, nationalCode?: string, postalCode?: string, ownerNatioalCode?: string, address?: string, telePhone?: string) => {

    let res = await axios.post(apiPath + '/taxInfo/ModifyTaxInfo', {
        labId,
        economicCode,
        nationalCode,
        postalCode,
        ownerNatioalCode,
        address,
        telePhone
    }, checkToken());

    return res;
}

const uploadpayStatment = async (labId: number, userId: number, taxBase64: String, payId: number) => {

    let res = await axios.post(apiPath + '/taxInfo', {
        labId,
        smsRequest: 0,
        desc: '',
        userId,
        taxBase64,
        withSign: true,
        payId
    }, checkToken());

    return res;
}

const getBase64Statement = async (labId?: number, payId?: number) => {

    let res = await axios.get(apiPath + '/taxInfo?labId=' + labId + '&payId=' + payId, checkToken());

    return res;
}

const getBillDetail = async (billId?: number) => {

    let res = await axios.get(apiPath + '/labBill?billId=' + billId, checkToken());
    return res;
}

const getBillType = async () => {

    let res = await axios.get(apiPath + '/labBill/billType', checkToken());

    return res;
}




const getCableRequestList = async () => {

    let res = await axios.get(apiPath + '/cableRequest', checkToken());

    return res;
}

const completeMakingCable = async (cableRequestId: number, labId: number) => {

    let res = await axios.post(apiPath + '/cableRequest/makeCable', {
        cableRequestId,
        labId
    }, checkToken());

    return res;
}

const sendCable = async (cableRequestId: number, requestId: number, labId: number, desc: string) => {

    let res = await axios.post(apiPath + '/cableRequest/sendCable', {
        cableRequestId,
        requestId,
        labId,
        desc
    }, checkToken());

    return res;
}

const noCableNeed = async (cableRequestId: number, requestId: number) => {

    let res = await axios.post(apiPath + '/cableRequest/NoCableNeed', {
        cableRequestId,
        requestId
    }, checkToken());

    return res;
}

const newCableRequest = async (requestId: number) => {

    let res = await axios.post(apiPath + '/cableRequest', {
        requestId
    }, checkToken());

    return res;
}




const getSMSrequestBalance = async (labId?: number) => {

    let res = await axios.get(apiPath + '/smsRequest?labId=' + labId + '&dateFrom=&dateTo=', checkToken());

    return res;
}

const applySMSRequest = async (labId: number, parsicUserId: number, appliedPrice: number, description: string) => {

    let res = await axios.post(apiPath + '/smsRequest', {
        labId,
        parsicUserId,
        appliedPrice,
        description,
        type: 1
    }, checkToken());

    return res;
}

const getRequestLabSupport = async (dateFrom: any = undefined, dateTo: any = undefined, byFinancial: any = undefined) => {

    //var Path = "http://192.168.1.20:8074/api"
    let fromdate = '';
    let toDate = '';

    if (dateFrom != undefined) {
        fromdate = jalali_moment.from(dateFrom, 'fa', 'YYYY-M-D')
            .format('YYYY-M-D');
    }
    if (dateTo != undefined) {
        toDate = jalali_moment.from(dateTo, 'fa', 'YYYY-M-D')
            .format('YYYY-M-D');
    }
    let res = await axios.get(apiPath + '/installRequest?fromDate=' +
        (fromdate ? fromdate : '') + '&toDate=' + (toDate ? toDate : '') + '&byFinancial=' + (byFinancial ? byFinancial : 2)
        , checkToken());

    return res;
}
const getRequestLabParsicUser = async (userId: any) => {

    let res = await axios.get(apiPath + '/installRequest/parsicuser?userId=' +
        (userId ? userId : ''), checkToken());

    return res;
}
const getRequestLabisLabUser = async (labId: any) => {

    let res = await axios.get(apiPath + '/installRequest/labId?labId=' +
        (labId ? labId : ''), checkToken());

    return res;
}
const getDeliveryType = async () => {


    let res = await axios.get(apiPath + '/DeliveryInstall/type', checkToken());

    return res;
}
const getDeliveryItems = async (typeId: any = undefined, labId: any = undefined, userId: any) => {


    let res = await axios.get(apiPath + '/DeliveryInstall/itemVDelivery?typeId=' +
        //  (typeId?typeId:0)+ '&labId='+(labId?labId:0)+ '&userId='+(userId?userId:0),checkToken());
        (typeId ? typeId : 0) + '&labId=' + (labId ? labId : 0), checkToken());

    return res;
}
const getDeliveryInstall = async (model: any) => {

    let res = await axios.post(apiPath + '/DeliveryInstall', model, checkToken());

    return res;
}
const getDeliveryInstallPut = async (model: any) => {

    let res = await axios.put(apiPath + '/DeliveryInstall', model, checkToken());

    return res;
}
const getRequestVmachine = async (prk_installLabRequest_AutoID: any = undefined) => {


    let res = await axios.get(apiPath + '/installRequestVmachine/?requestInstallId=' +
        (prk_installLabRequest_AutoID ? prk_installLabRequest_AutoID : 0), checkToken());

    return res;
}
const getMachineRequest = async (model: any) => {

    let res = await axios.post(apiPath + '/machineRequest', model, checkToken());

    return res;
}
const getMachineRequestWhithOutConfirm = async (model: any) => {

    let res = await axios.post(apiPath + '/LabPay/payMachineVInstallRequest', model, checkToken());

    return res;
}
const newCenteralInstall = async (model: any) => {

    let res = await axios.post(apiPath + '/installRequest/CenteralInstall', model, checkToken());

    return res;
}
const requestLabFactor = async (model: any) => {
    let res = await axios.post(apiPath + '/labBill/labInstallBill',
        model
        , checkToken());

    return res;
}

const getPaymentgetwayRequest = async (labId: number) => {


    let res = await axios.get(apiPath + '/paymentgetwayRequest?labId=' + (labId ? labId : 0), checkToken());

    return res;
}
const newPaymentgetwayRequest = async (model: any) => {


    let res = await axios.post(apiPath + '/paymentgetwayRequest', model, checkToken());

    return res;
}
const updatePaymentgetwayRequest = async (model: any) => {


    let res = await axios.put(apiPath + '/paymentgetwayRequest', model, checkToken());

    return res;
}
const newPaymentgetwayRequestUpload = async (model: any) => {


    let res = await axios.post(apiPath + '/paymentgetwayFiles', model, checkToken());

    return res;
}

const getpaymentgetwayFiles = async (machineId: number) => {

    let res = await axios.get(apiPath + '/paymentgetwayFiles?requestId=' + machineId, checkToken());

    return res;
}

const CheckConnection = async (service_url: string) => {

    let pingFlag: boolean = false;
    try {
        const response = await axios.get(service_url);

        if (response.status === 200) {
            pingFlag = true;
        }
        else {
            pingFlag = false;
        }
    } catch (error) {
        pingFlag = false;
    }
    return pingFlag;
}


const getLabBackupInfo = async (url: string) => {
    //url = myURL;
    debugger;
    if (url.includes('asmx'))
        return null;
    else {
        let res = await axios.get(url + '/api/v1/ticket/autoBackUpInfo', checkToken());
        //console.log('backup are: '+res.data.JSON);
        return res;
    }

}

const getLabBackupLog = async (url: string, typeId: number, fromId: number) => {
    //url=myURL;
    let res = await axios.get(url + '/api/v1/ticket/autoBackUpLog?type=' +
        (typeId ? typeId : 0) + '&fromId=' + (fromId ? fromId : 0), checkToken());
    return res;
}

const getLabSystems = async (url: string) => {
    let res = await axios.get(url + '/api/v1/ticket/clientComputerInformation', checkToken());
    return res;
}

const getLabVersions = async (url: string, typeId: number, number: number) => {
    let res = await axios.get(url + '/api/v1/ticket/logVersion?typeId=' +
        (typeId ? typeId : 0) + '&number=' + (number ? number : 0), checkToken());
    return res;
}

const getLabProcess = async (url: string, optionName: string, wantWebOPtion: boolean, app: Number) => {
    //url = myURL;

    if (url.includes('asmx'))
        return null;
    else {
        let res = await axios.get(url + '/api/v1/shared/option/api/v1/shared/option/Option?optionName=' +
            (optionName ? optionName : "") + '&wantWebOPtion=' + (wantWebOPtion ? wantWebOPtion : false + '&app=' + app), checkToken());
        let result = res.data.json;
        if (result == "NotFound") {
            return {
                processList: [],
                innerArray: []
            };
        }
        let resultArray = result.split('|');
        let processArray: string[] = [];
        let inner_array: string[][] = [];
        resultArray.map((item: any) => {
            if (item) {
                let secondProcessArray: string[] = [];
                let itemArray = item.split(';');

                let subItemArray = itemArray[0].split(',');
                // let firstChar = subItemArray[0];
                // let name = getProcessName(firstChar);
                // name && processArray.push(name); 

                subItemArray.map((item: any) => {
                    let name = getProcessName(item);
                    name && secondProcessArray.push(name);
                }

                )
                processArray.push(secondProcessArray[0]);

                let subItemArray2 = itemArray[1].split(',');
                subItemArray2.map((item: any) => {
                    item && secondProcessArray.push(item);
                }
                )

                inner_array.push(secondProcessArray);
            }
        }

        )

        let all_res = {
            processList: processArray,
            innerArray: inner_array
        }
        return all_res;
    }
}

const getProcessName = (firstChar: string) => {
    let name = "";
    switch (firstChar) {
        case '-2':
            name = 'پذیرش';
            break;
        case '-1':
            name = 'تایید پذیرش';
            break;
        case '0':
            name = 'هزینه';
            break;
        case '1':
            name = 'سوال و جواب';
            break;
        case '2':
            name = 'نمونه برداری';
            break;
        case '3':
            name = 'تفکیک';
            break;
        case '4':
            name = 'رسید بخش';
            break;
        case '5':
            name = 'جواب';
            break;
        case '6':
            name = 'تایید بخش';
            break;
        case '7':
            name = 'تایید آزمایشگاه';
            break;
        case '8':
            name = 'آماده';
            break;
        case '9':
            name = 'چاپ';
            break;
        case '10':
            name = 'تحویل جوابدهی';
            break;
        case '11':
            name = 'تحویل جواب';
            break;
        default:
            break;
    }
    return name;
}

const getGeneralLabInformation = async (url: string) => {
    // url = myURL;
    let res = await axios.get(url + '/api/v1/parsitel/controlPanelBrief', checkToken());
    return res;
}

const getLabFeedback = async (url: string) => {
    //url = myURL;
    if (url.includes('asmx'))
        return null;
    else {
        let res = await axios.get(url + '/api/v1/ticket/insightsFeedBack', checkToken());
        //console.log('backup are: '+res.data.JSON);
        return res;
    }

}

const getClientComputerInformation = async (url: string) => {
    //url = myURL;
    let jsonArray: any[] = [];

    if (url.includes('asmx'))
        return null;
    else {
        let res = await axios.get(url + '/api/v1/ticket/clientComputerInformation', checkToken());
        if (res.data.json != "{}") {
            let jsonResult = JSON.parse(res.data.json);
            let clientinfo = jsonResult.ClinetInfo;
            clientinfo.map((item: any) => {
                //console.log(item.Str_XMLInformation);
                let jsonRes = ParsXML(item.Str_XMLInformation);
                jsonArray.push(jsonRes);
            })

        }
        return jsonArray;
    }

}

const ParsXML = (xmlStr: string) => {
    //const xmlStr = '<?xml version="1.0" encoding="utf-16"?><ClientProopertyInfo xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema">    <Computername>NEMONE</Computername>    <MyLocalIp>192.168.1.106</MyLocalIp>    <CentralUserName>ليلا مرادي</CentralUserName>    <CentralVer>11.28</CentralVer>    <JournalVer />    <internet>true</internet>    <CheckSQLConnectionString>true</CheckSQLConnectionString>    <MySQLConnectionString>server=PARSIC\SQL2012;database=Sina96;user id=sa;password=U2VvFtm6gxNkE30haSCBegMKp4wMWEn0kDsfePA6CU0=;Max Pool Size=200;</MySQLConnectionString>    <ComputerUserName>NEMONE\NEMONE</ComputerUserName>    <WinDowsInformation>Microsoft Windows 10 Enterprise          6.2.9200.0</WinDowsInformation>    <RamInfo>Total Memory : 3.85 GB     Available Memory : 1.93 GB</RamInfo>    <HardSize>C: 53 GB Free Of 97.1 GB     </HardSize>    <CPU>Intel(R) Celeron(R) CPU  J3160  @ 1.60GHz</CPU>    <IsAdmin>true</IsAdmin>    <PadvishIsInstaled>true</PadvishIsInstaled>    <PadvishIsRun>true</PadvishIsRun>    <FireWall>Domain:True  Private:True  Public:True</FireWall>    <RemotDescPortIsOpen>false</RemotDescPortIsOpen></ClientProopertyInfo>';
    const parser = new DOMParser();
    const doc = parser.parseFromString(xmlStr, "application/xml");
    const errorNode = doc.querySelector("parsererror");
    if (errorNode) {
        console.log("error while parsing");
    } else {
        console.log(doc.documentElement.nodeName);
        console.log(doc.childNodes[0].childNodes);
        let nodeList = doc.childNodes[0].childNodes;
        let inner = doc.querySelector('Computername')?.innerHTML;
        console.log("inner is:" + inner);

        let XMLTags = {
            Computername: doc.querySelector('Computername')?.innerHTML,
            MyLocalIp: doc.querySelector('MyLocalIp')?.innerHTML,
            CentralUserName: doc.querySelector('CentralUserName')?.innerHTML,
            CentralVer: doc.querySelector('CentralVer')?.innerHTML,
            JournalVer: doc.querySelector('JournalVer')?.innerHTML,
            internet: doc.querySelector('internet')?.innerHTML,
            CheckSQLConnectionString: doc.querySelector('CheckSQLConnectionString')?.innerHTML,
            MySQLConnectionString: doc.querySelector('MySQLConnectionString')?.innerHTML,
            ComputerUserName: doc.querySelector('ComputerUserName')?.innerHTML,
            WinDowsInformation: doc.querySelector('WinDowsInformation')?.innerHTML,
            RamInfo: doc.querySelector('RamInfo')?.innerHTML,
            HardSize: doc.querySelector('HardSize')?.innerHTML,
            CPU: doc.querySelector('CPU')?.innerHTML,
            IsAdmin: doc.querySelector('IsAdmin')?.innerHTML,
            PadvishIsInstaled: doc.querySelector('PadvishIsInstaled')?.innerHTML,
            PadvishIsRun: doc.querySelector('PadvishIsRun')?.innerHTML,
            FireWall: doc.querySelector('FireWall')?.innerHTML,
            RemotDescPortIsOpen: doc.querySelector('RemotDescPortIsOpen')?.innerHTML,
        }

        return XMLTags;
    }

}

const getMiscellaneousFunctions = async (url: string, func: number, fromDate: string, toDate: string) => {
    //url=myURL;
    let res = await axios.get(url + '/api/v1/ticket/miscellaneousFunctions?Function=' +
        (func ? func : 0) + '&fromDate=' + (fromDate ? fromDate : "") + '&toDate=' + (toDate ? toDate : ""), checkToken());
    return res;
}

const getRemoteAccessList = (jsonResult: any) => {
    let remoteAccessList: any[] = [];
    jsonResult.map((item: any) => {
        let remote = {
            count: item.Tedad,
            sub_source: item.Str_SubSource,
            source: item.Str_Source
        };
        if (remoteAccessList.length < 1) {
            remoteAccessList.push(remote);
            return;
        }
        let index: number = remoteAccessList.findIndex(x => x.sub_source == item.Str_SubSource);
        if (index >= 0) {
            let count = remoteAccessList[index].count + item.Tedad;
            remoteAccessList[index].count = count;
        }
        else {
            remoteAccessList.push(remote);
        }
    });
    return remoteAccessList;
}

const getUsersList = async (url: string, baseType: number, tubeId: number, groupTestId: number, isForAdmit: boolean) => {
    //url = myURL;
    //let res =  await axios.get(url+'/api/v1/shared/baseDeta/baseData/'+baseType,checkToken());
    let res = await axios.get(url + '/api/v1/shared/baseDeta/baseData?baseType=' + baseType + '&tubeId=' + tubeId + '&groupTestId=' + groupTestId + '&isForAdmit=' + isForAdmit, checkToken());

    return res;
}

const sendMessageToUser = async (url: string, userId: number, subject: string, messageBody: string) => {
    //url = myURL;
    // let  myMessageInfo=
    // {
    // "listofemailSysUsers": [
    // {
    //     "userId": 0,
    //     "userName": "",
    //     "name": ""
    // }
    // ],
    // "emailAttaches": [
    //     {
    //     "fileName": "",
    //     "fileExtension": "",
    //     "fileContent": ""
    //     }
    // ],
    // "emailSysUser": {
    //     "userId": 0,
    //     "userName": "",
    //     "name": ""
    // },
    // "prk_EmailSys_Message_AutoID": 0,
    // "subject": subject,
    // "body": messageBody,
    // "sendDate": moment( new Date()).format('L'),
    // "sendTime": moment(new Date()).format('LT'),
    // "voiceNotification": true,
    // "computeName": "MainServer",
    // "deleted": false,
    // "userId": userId
    // }

    let res = await axios.post(url + '/api/v1/parsitel/InboxOutBox', {
        reciveuserId: userId,
        messageBody: messageBody,
        messageTitle: subject
    }, checkToken());

    return res;
}

const getMessageOfUser = async (url: string, userId: number) => {

    let res = await axios.get(url + '/api/v1/parsitel/InboxOutBox?userId=' + userId, checkToken());
    //let res =  await axios.get('http://193.151.128.199:8086/api/v1/parsitel/InboxOutBox?userId=0',checkToken());
    return res;

}


const modifyTaxInfo = async (labId: number, inputVals: any) => {

    let taxInfo = {
        labId,
        "economicCode": inputVals.economicCode,
        "nationalCode": inputVals.nationalCode,
        "postalCode": inputVals.postalCode,
        "ownerNatioalCode": inputVals.ownerNatioalCode,
        "address": inputVals.address,
        "telePhone": inputVals.telePhone
    }

    let res = await axios.post(apiPath + '/taxInfo/updateTaxInfo', {
        taxInfo
    }, checkToken());

    return res;
}

const sendSMS = async (labId: number) => {
    //labId = 3130;
    let res = await axios.get(apiPath + '/taxInfo/SendSms?labId=' + labId, checkToken());
    return res;
}

const modifyPayInfo = async (labId: number, payId: number, billId: string, date1: any) => {
    //labId = 3130;
    let date = jalali_moment.from(date1, 'fa', 'YYYY-M-D')
        .format('YYYY-M-D');
    //date = moment( new Date()).format('L');
    let res = await axios.get(apiPath + '/LabPay/ModifyPayInfo?Labid=' +
        (labId ? labId : 0) + '&payId=' + (payId ? payId : 0) + '&BillId=' + (billId ? billId : 0)
        + '&Date=' + date, checkToken());
    return res;
}


const ExecelTaxInvoiceInfo = async (fromDate: any, toDate: any) => {
    let dateFrom = fromDate ? jalali_moment.from(fromDate, 'fa', 'YYYY-M-D')
        .format('YYYY-M-D') : '';
    let dateTo = toDate ? jalali_moment.from(toDate, 'fa', 'YYYY-M-D')
        .format('YYYY-M-D') : '';
    let res = await axios.get(apiPath + '/taxInfo/ExeceltaxInvoiceInfo?fromDate=' + dateFrom + '&toDate=' + dateTo, checkToken());

    return res;
}

const MakeTaxInvoice = async (labId: number[], discount: number) => {
    //labId = 26;
    let username = 'Ticketing';
    let password = 'wM/Gu46BZXh9ObQBZl5dqxcbEcHrq7QA8a9ao5B8EDgx4CSDZfs7W0E5eebJ3ygq8dIrOwEzZmJA0xHedlHnxXEwHu17uHFzUL2zBaNik0ru/UfLcQAq0tgH40l8YIOthHfW0k2teKg=';

    let res = await axios.get('http://my.pws.ir/service1.asmx/MakeTaxInvoice?UserName=' + username + '&Password=' + password + '&labId=' + labId + '&discount=' + discount);
    let ret: string = res.data.replace('<?xml version="1.0" encoding="utf-8"?>', '');
    let ret2: string = ret.replace('<string xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:nil="true" xmlns="http://tempuri.org/" />', '')
    let ret3: string[] = ret2.split('\r\n');
    let result = JSON.parse(JSON.stringify(ret3[0]));
    console.log(result);

    return result;
}

const getTaxInfoLabIds = (taxList: any) => {

    let IdList: number[] = [];
    taxList.map((item: any) => {
        let index: number = IdList.indexOf(item.frk_LabID);
        if (index < 0)
            IdList.push(item.frk_LabID);
    });

    return IdList;
}

const getQuickSearchResult = async (url: string, searchMode: number, searchValue: string) => {
    //searchMode = 1;
    //searchValue = '180160';
    let searchRange = 3;
    let workArea = -1;
    let virtulLab = -1;

    var url_json = JSON.parse(JSON.stringify(url));
    var api_url = url_json.url + "/api/v1/shared/patientInfo/general/quickSearch";
    let res = await axios.post(api_url, {
        searchMode,
        searchValue,
        searchRange,
        workArea,
        virtulLab,

    }, checkToken());

    return res;
}

const deleteMachineRequest = async (requestId: number, deleted: boolean) => {
    let res = await axios.put(apiPath + '/machineRequest/deletemachinerequest', {
        requestId,
        deleted
    }, checkToken());

    return res;
}



const getTemperatureRequestList = async (dateFrom: any, dateTo: any) => {
    if (dateFrom != "") {
        dateFrom = jalali_moment.from(dateFrom, 'fa', 'YYYY-MM-DD')
            .format('YYYY-MM-DD');
    }
    if (dateTo != "") {
        dateTo = jalali_moment.from(dateTo, 'fa', 'YYYY-MM-DD')
            .format('YYYY-MM-DD');
    }
    let res = await axios.get(apiPath + '/temperatureRequest?dateFrom=' + dateFrom + '&dateTo=' + dateTo, checkToken());
    return res;
}

const getTemperatures = async () => {
    //url = myURL;
    let res = await axios.get(apiPath + '/temperatureInfo', checkToken());
    return res;
}
const insertTemperatureInstallRequestList = async (temperatureId: number, labId: number, mobile: string, description: string, countRefrigerator: number) => {
    let res = await axios.post(apiPath + '/temperatureRequest', {
        temperatureRequest: 0,
        temperatureId: temperatureId,
        requestTemperaturecsStatus: 0,
        deleted: false,
        underRepair: false,
        countRefrigerator: countRefrigerator,
        mobile: mobile,
        labId: labId,
        manufacturerId: 0,
        sender: 0,
        description: description,
        financialUserId: 0
    }, checkToken());
    return res;
}

const deleteTempratureRequest = async (temperatureRequest: number, deleted: boolean) => {
    let res = await axios.put(apiPath + '/temperatureRequest/deleteRequest', {
        temperatureRequest,
        deleted
    }, checkToken());

    return res;
}

const temperatureInstallManualPay = async ({ requestId, labId, billId, userId, bankAccount, payType, title, payAmount, description }: manualPay) => {

    let res = await axios.post(apiPath + '/LabPay/temperature', {
        requestId,
        labId,
        billId,
        userId,
        bankAccount,
        payType,
        title,
        payAmount,
        description
    }, checkToken());

    return res;
}

const makingTemperature = async (temperatureRequest: number, manufacturerId: number, financialUserId: number) => {
    let res = await axios.put(apiPath + '/temperatureRequest/ManufacturerApprove', {
        temperatureRequest,
        manufacturerId,
        financialUserId
    }, checkToken());

    return res;
}
const sendingTemperature = async (temperatureRequest: number, sender: number, financialUserId: number) => {
    let res = await axios.put(apiPath + '/temperatureRequest/SenderApprove', {
        temperatureRequest,
        sender,
        financialUserId
    }, checkToken());

    return res;
}
const getLabTemperatureRequestList = async (labId: number) => {
    let res = await axios.get(apiPath + '/temperatureRequest/Lab?labId=' + labId, checkToken());
    return res;

}

const getPadvishRequestList = async () => {
    let res = await axios.get(apiPath + '/padvishRequest', checkToken());
    return res;

}
const getLabPadvishRequestList = async (labId: number) => {
    let res = await axios.get(apiPath + '/padvishRequest/lab?labId=' + labId, checkToken());
    return res;

}

const insertPadvishRequestList = async (labId: Number, mobile: string, countUser: Number) => {
    let res = await axios.post(apiPath + '/padvishRequest', {
        requestId: 0,
        labId,
        mobile,
        countUser,
        userId: 0

    }, checkToken());

    return res;
}

const padvishRequestFinancialApprove = async (requestId: Number) => {
    let res = await axios.put(apiPath + '/padvishRequest/ApproveFinancial', {
        requestId,
        labId: 0,
        mobile: "",
        countUser: 0,
        userId: 0
    }, checkToken());

    return res;
}

const padvishRequestInstallerApprove = async (requestId: Number, userId: Number) => {
    let res = await axios.put(apiPath + '/padvishRequest/ApproveInstaller', {
        requestId,
        userId,
        labId: 0,
        mobile: "",
        countUser: 0,

    }, checkToken());

    return res;
}

const getPadvishRequestLicense = async (requestId: number) => {
    let res = await axios.get(apiPath + '/padvishLicense?requestId=' + requestId, checkToken());
    return res;

}

const insertPadvishRequestLicense = async (requestId: Number, accountId: Number, consoleComputerName: string, consoleComputerIp: string,
    consoleVersion: string, expireDate: string, license: string, licenseCount: Number) => {
    let res = await axios.post(apiPath + '/padvishLicense', {
        accountId: accountId ? accountId : 0,
        requestId,
        consoleComputerName,
        consoleComputerIp,
        consoleVersion,
        expireDate,
        license,
        licenseCount,
        accountStatus: 0,
        tranferId: 0
    }, checkToken());

    return res;
}

const updatePadvishLicenseStatus = async (accountId: Number, requestId: Number, licenseCount: Number, accountStatus: Number) => {
    let res = await axios.put(apiPath + '/padvishLicense', {
        accountId,
        requestId,
        licenseCount,
        accountStatus
    }, checkToken());

    return res;
}

const padvishLicenseInstallation = async (accountId: Number, requestId: Number) => {
    let res = await axios.put(apiPath + '/padvishLicense/ApproveInstall', {
        accountId,
        requestId
    }, checkToken());

    return res;
}

const padvishLicenseTransfer = async (accountId: Number, tranferId: Number) => {
    let res = await axios.put(apiPath + '/padvishLicense/Tranfer', {
        accountId,
        tranferId,
    }, checkToken());

    return res;
}

const getTicketList = async (userId: Number, labId: Number, fromDate: any, toDate: any) => {

    let fDate = '';
    let lDate = '';

    if (fromDate != undefined) {
        fDate = jalali_moment.from(fromDate, 'fa', 'YYYY-M-D')
            .format('YYYY-M-D');
    }
    if (toDate != undefined) {
        lDate = jalali_moment.from(toDate, 'fa', 'YYYY-M-D')
            .format('YYYY-M-D');
    }

    let res = await axios.get(apiPath + '/supportTicket?userId=' + userId + '&labId=' + labId + '&fromDate=' + fDate + '&toDate=' + lDate, checkToken());
    return res;

}

const getTicketThread = async (ticketId: Number) => {
    //ticketId = 61741;
    let res = await axios.get(apiPath + '/supportTicket/TicketThread?ticketId=' + ticketId, checkToken());
    return res;

}


const getBaseData = async (url: string, baseType: number, tubeId: number, groupTestId: number, isForAdmit: boolean) => {

    let res = await axios.get(url + '/api/v1/shared/baseDeta/baseData?baseType=' + baseType + '&tubeId=' + tubeId + '&groupTestId=' + groupTestId + '&isForAdmit=' + isForAdmit, checkToken());
    return res;
}

// const getLabReport = async (_ReportAreaLab:any,_FirstDate:string,_LastDate:string,_FirstTime:string,_LastTime:string,_UserID:any,_VirtualLab:any,
//     _VirtualName:string,_WorkArea:any,_WithDetailReport:boolean,_TimeIntervalMode:number,_Tests:number,_JustEmergency:boolean,_DepName:string,
//     _TubeName:string,_GroupName:string,_TestName:string,_AdmitPatientType:number,_WorkAreaName:string) =>{
const getLabReport = async (service_url: string, values: any) => {

    //let username = 'AngularWeb';
    //  let password = 'HUpxKoJIjW%2FWRU%2FRIRm%2B57NQThUNKRvBBfrZOKjqaB6aIzMXFR%2BGL3R%2BhnhEdx0p6Gp2vDKxPhKUIsvHxmBirg%3D%3D';
    //let password = "sdy5r1rFOmC7DtyOq0RE0Lwb%2BSmLzzb8BtL95s%2FBh16cNsSAvjbOK16zbPLxaEr%2B";

    let username = "android";
    let password = "diordna";
    const _ReportAreaLab = values.report.value;
    const _FirstDate = values.firstDate;
    const _LastDate = values.lastDate;
    const _FirstTime = values.fromTime;
    const _LastTime = values.toTime;
    const _UserID = values.userId.value;
    const _VirtualLab = values.virtualLabId.value;
    const _VirtualName = values.virtualLabId.label;
    const _WorkArea = -1;
    const _WorkAreaName = "همه";
    const _WithDetailReport = values.isReportDetails;
    const _TimeIntervalMode = values.reportPeriod.value;
    const _Tests = values.test.value;
    const _JustEmergency = values.isEmergency;
    const _DepName = values.department.label;
    const _TubeName = values.tubeId.label;
    const _GroupName = values.groupId.label;
    const _TestName = values.test.label;
    const _AdmitPatientType = values.reception.value;

    // let username = "android";
    // let password = "diordna";
    // const _ReportAreaLab = 0;
    // const _FirstDate = "1402/01/01";
    // const _LastDate = "1402/11/13";
    // const _FirstTime = "06:00:00";
    // const _LastTime = "23:59:59";
    // const _UserID = 0;
    // const _VirtualLab = -1;
    // const _VirtualName = "";
    // const _WorkArea = -1;
    // const _WorkAreaName = "همه";
    // const _WithDetailReport = true;
    // const _TimeIntervalMode = 1;
    // const _Tests = 0;
    // const _JustEmergency = false;
    // const _DepName = "";
    // const _TubeName = "همه";
    // const _GroupName = "همه";
    // const _TestName = "همه";
    // const _AdmitPatientType = 0;

    if (!service_url.includes("Service1.asmx"))
        service_url = service_url + "/Service1.asmx";

    if (!service_url.includes("http")) {
        service_url = "http://" + service_url;
    }

    let res = await axios.get(service_url + '/Web_Qmatic_Performance_Json?UserName=' + username + '&Password=' + password + '&_ReportAreaLab=' + _ReportAreaLab + '&_FirstDate=' + _FirstDate
        + '&_LastDate=' + _LastDate + '&_FirstTime=' + _FirstTime + '&_LastTime=' + _LastTime + '&_UserID=' + _UserID
        + '&_VirtualLab=' + _VirtualLab + '&_VirtualName=' + _VirtualName + '&_WorkArea=' + _WorkArea + '&_WorkAreaName=' + _WorkAreaName
        + '&_WithDetailReport=' + _WithDetailReport + '&_TimeIntervalMode=' + _TimeIntervalMode + '&_Tests=' + _Tests + '&_JustEmergency=' + _JustEmergency
        + '&_DepName=' + _DepName + '&_TubeName=' + _TubeName + '&_GroupName=' + _GroupName + '&_TestName=' + _TestName + '&_AdmitPatientType=' + _AdmitPatientType);

    return res;

}

const sendMessage = async (msgText: string, phoneNumbers: string[]) => {

    let res = await axios.post(apiPath + '/SendMessage', {
        messageText: msgText,
        mobileNumber: phoneNumbers
    }, checkToken());

    return res;
}

const getSMSQueue = async (url: string, fromDate: any, toDate: any) => {

    let fDate = '';
    let lDate = '';

    if (fromDate != undefined) {
        fDate = jalali_moment.from(fromDate, 'fa', 'YYYY-M-D')
            .format('YYYY-M-D');
    }
    if (toDate != undefined) {
        lDate = jalali_moment.from(toDate, 'fa', 'YYYY-M-D')
            .format('YYYY-M-D');
    }

    // url = "http://193.151.128.199:8086";
    let res = await axios.get(url + '/api/v1/ticket/smsService/smsQueue?fromDate=' + fDate + '&ToDate=' + lDate, checkToken());

    return res;
}

const getLabInfo = async (url: string) => {
    // let username = 'AngularWeb';
    //  let password = 'HUpxKoJIjW%2FWRU%2FRIRm%2B57NQThUNKRvBBfrZOKjqaB6aIzMXFR%2BGL3R%2BhnhEdx0p6Gp2vDKxPhKUIsvHxmBirg%3D%3D';
    //let password = "sdy5r1rFOmC7DtyOq0RE0Lwb%2BSmLzzb8BtL95s%2FBh16cNsSAvjbOK16zbPLxaEr%2B";

    var url_array: any[] = url.split(':');

    url.replace("http://", "");
    url.replace("https://", "")

    let username = "android";
    let password = "diordna";
    const IISURL = url_array[0];
    const LabOnlinePort = url_array[1].split('/')[0];

    if (!url.includes("Service1.asmx")) {
        url = url + "/Service1.asmx";
    }
    if (!url.includes("http")) {
        url = "http://" + url;
    }

    let res = await axios.get(url + '/GetServerInfo_Json?UserName=' + username + '&Password=' + password + '&IISURL=' + IISURL + '&LabOnlinePort=' + LabOnlinePort);

    let ret: string = res.data.replace('<?xml version="1.0" encoding="utf-8"?>\r\n<string xmlns="http://tempuri.org/">', '');
    //let ret2:string = ret.replace('<string xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:nil="true" xmlns="http://tempuri.org/" />','')
    //let ret3:string[] = ret2.split('\r\n');
    let ret2: string = ret.replace('</string>', '');
    let result = JSON.parse(ret2);
    console.log(result);
    //console.log(result.DsSQLBackupInfo.SqlBackup);

    return result;

}

const convertBase64 = (file: any) => new Promise((resolve, reject) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(file)

    fileReader.onload = () => {
        resolve(fileReader.result)
    }

    fileReader.onerror = (error) => {
        reject(error)
    }
})

const convertBase64ToFile = (base64String: any, fileName: any) => {
    let arr = base64String.split(',');
    let mime = arr[0].match(/:(.*?);/)[1];
    let bstr = atob(arr[1]);
    let n = bstr.length;
    let uint8Array = new Uint8Array(n);
    while (n--) {
        uint8Array[n] = bstr.charCodeAt(n);
    }
    let file = new File([uint8Array], fileName, { type: mime });
    return file;
}

const addPaymentgetwayFiles = async (values: any) => {
    let res = await axios.post(apiPath + '/paymentgetwayFiles', { values }, checkToken());

    return res;
}

const downloadPaymentGetwayAttachments = async (requestId: number) => {
    let res = await axios.get(apiPath + '/paymentgetwayFiles?requestId=' + requestId, checkToken());

    return res;
}

const checkSite = async (url: string) => {
    //url = "http://193.151.128.199:8086";
    let res = await axios.get(url + '/api/v1/ticket/miscellaneousFunctions/checkSite', checkToken());

    return res;
}

const getVoipToken = async () => {
    axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
    let res = await axios.get("https://192.168.1.10/api/getPassword.php?passkey=parsicpolvoip");
    return res;
}

const getVoipList = async (labId: number, firstDate: any, lastDate: any) => {

    let res = await axios.get("https://online.parsipol.com:9599/api/Logvoip?labid=" + labId + "&userId=" + '0' + "&fromDate=" + firstDate + "&ToDate=" + lastDate, checkToken());
    return res;
}

const getPersonnelVoips = async (labId: number, exten: number, firstDate: any, lastDate: any) => {

    let res = await axios.get("https://online.parsipol.com:9599/api/Logvoip?labid=" + labId + "&userId=" + exten + "&fromDate=" + firstDate + "&ToDate=" + lastDate, checkToken());
    return res;
}

const getAnonymousCalls = async (firstDate: any, lastDate: any) => {

    let res = await axios.get("https://online.parsipol.com:9599/api/Logvoip?labid=0&userId=0&fromDate=" + firstDate + "&ToDate=" + lastDate, checkToken());
    return res;
}

const setVoipReports = async (model: any) => {

    let res = await axios.post(apiPath + '/Logvoip/SetVoipVReport',
        model, checkToken());

    return res;
}

const getVoipReports = async (labId: number, userId: number, fromDate: any, toDate: any) => {
    let res = await axios.get(apiPath + "/Logvoip/GetVoipReport?labId=" + labId + "&userId=" + userId + "&DateFrom=" + fromDate + "&DateTo=" + toDate, checkToken());
    return res;
}

const getPatientResultReport = async (url: string, AdmitID: number, app: number, _IncludeInCompletePatient: boolean, _IncludePrintedPatient: boolean, _IncludedNotConfirmedPatient: boolean) => {
    let username = "android";
    let password = "diordna";

    let res = await axios.get(url + '/Web_ResultReport_AllInOneBase64PDF_WithSQLDbID_Json?UserName=' + username + '&Password=' + password + '&SQLDbID=0&AdmitID=' + AdmitID + '&app=' + app + '&_IncludeInCompletePatient=' + _IncludeInCompletePatient +
        '&_IncludePrintedPatient=' + _IncludePrintedPatient + '&_IncludedNotConfirmedPatient=' + _IncludedNotConfirmedPatient +
        '&_MyCaller=1&_WithoutPayLimitCheck=false&_CheckInterview=true&_requester=0&_SourceLogRemoteDelivery=0');

    return res;

}

const getPatientCostReceipt = async (url: string, AdmitID: number, app: number) => {
    //url = "http://localhost:8585/service1.asmx"
    let username = "android";
    let password = "diordna";

    let res = await axios.get(url + '/TelegramBot_PatientCostReceipt_Base64PDFWithDbId?UserName=' + username + '&Password=' + password + '&AdmitID=' + AdmitID + '&app=' + app + '&dbId=0');
    console.log(res);
    let ret: string = res.data.replace('<?xml version="1.0" encoding="utf-8"?>\r\n<string xmlns="http://tempuri.org/">', '');
    let ret2: string = ret.replace('</string>', '')
    // let ret3: string[] = ret2.split('\r\n');
    //let result = JSON.parse(JSON.stringify(ret3[0]));
    console.log(ret2);

    return ret2;
}

const AssignLab = async (model: any) => {

    let res = await axios.post('https://online.parsipol.com:9599/api/Logvoip',
        {
            labid: model.labid,
            name: model.name,
            number: model.number
        }, checkToken());

    return res;
}

const SendLink = async (url: string, admitId: string, app: number) => {
    //url = "http://localhost:8090"
    let res = await axios.get(url + "/api/v1/shared/patientInfo/general/quickSearch?AdmitId=" + admitId + "&app=" + app, checkToken());
    return res;
}

const getParsikConfig = async (labId: number) => {
    //labId = 3130;
    let res = await axios.get(apiPath + "/makeLabSql?labId=" + labId, checkToken());
    return res;
}


const sendNewParsinkConfig = async (labId: number, userId: number, userName: string,
    sqlInstance: string, computerName: string, macAddress: string, method: number) => {

    //labId = 3130;
    let res = await axios.post(apiPath + '/makeLabSql', {
        labId,
        userId,
        userName,
        sqlInstance,
        computerName,
        macAddress,
        method
    }, checkToken());

    return res;
}

const getScripts = async () => {
    let res = await axios.get(apiPath + "/makeLabSql/scripts", checkToken());
    return res;
}


const modifyLink = async (labId: number, previousLink: string, currentLink: string) => {
    //labId = 3130;
    let res = await axios.post(apiPath + '/lab/pws', {
        labId,
        perviousLink: previousLink,
        currentLink,

    }, checkToken());

    return res;
}

const getLabInstallationItems = async () => {
    let res = await axios.get(apiPath + "/DeliveryInstall/Type", checkToken());
    return res;
}

const assignInstaller = async (userId: number, userCreation: number, itemType: number, labId: number, desc: string) => {
    //userId=65;
    let res = await axios.post(apiPath + '/DeliveryInstall', {
        id: 0,
        userId,
        userCreation,
        itemType,
        labId,
        desc,
        done: 0,
        labApprove: 0
    }, checkToken());

    return res;
}

const getLabInstallerItems = async (userId: number, labId: number) => {
    //labId=6351;
    //userId=65;
    let res = await axios.get(apiPath + "/DeliveryInstall/DeliveyTypeUser?userId=" + userId + "&labId=" + labId, checkToken());
    return res;
}

const getLabInstallerItemDetails = async (DeliveryTypeVUser: number) => {

    let res = await axios.get(apiPath + "/DeliveryInstall/DeliveyItemUser?DeliveryTypeVUser=" + DeliveryTypeVUser, checkToken());
    return res;
}

const labInstallationTypeApproveUser = async (id: number, userId: number, userCreation: number, itemType: number, labId: number, desc: string) => {
    userId = 65;
    let res = await axios.post(apiPath + '/DeliveryInstall/DeliveyTypeApproveUser', {
        id,
        userId,
        userCreation,
        itemType,
        labId,
        desc,
        done: 1,
        labApprove: 0
    }, checkToken());

    return res;
}

const labInstallationItemsApproveUser = async (id: number, userId: number, userCreation: number, itemType: number, labId: number, desc: string) => {
    let res = await axios.post(apiPath + '/DeliveryInstall/DeliveyItemApproveUser', {
        id,
        userId,
        userCreation,
        itemType,
        labId,
        desc,
        done: 1,
        labApprove: 0
    }, checkToken());

    return res;
}

const labInstallationTypeApproveLab = async (id: number, userId: number, userCreation: number, itemType: number, labId: number, desc: string) => {
    let res = await axios.post(apiPath + '/DeliveryInstall/DeliveyTypeApproveLab', {
        id,
        userId,
        userCreation,
        itemType,
        labId,
        desc,
        done: 0,
        labApprove: 1
    }, checkToken());

    return res;
}

const labInstallationItemsApproveLab = async (id: number, userId: number, userCreation: number, itemType: number, labId: number, desc: string) => {
    let res = await axios.post(apiPath + '/DeliveryInstall/DeliveyItemApproveLab', {
        id,
        userId,
        userCreation,
        itemType,
        labId,
        desc,
        done: 0,
        labApprove: 1
    }, checkToken());

    return res;
}

const getOnlinePaymentReport = async (url: string, fromDate: any, toDate: any) => {

    if (!url.includes("Service1.asmx") && !url.includes("service1.asmx")) {
        url = url + "/Service1.asmx";
    }
    let fromdate = '';
    let todate = '';

    if (fromDate != undefined) {
        fromdate = jalali_moment.from(fromDate, 'fa', 'YYYY-M-D')
            .format('YYYY-M-D');
    }
    if (toDate != undefined) {
        todate = jalali_moment.from(toDate, 'fa', 'YYYY-M-D')
            .format('YYYY-M-D');
    }
    let username = 'android';
    let password = 'diordna';

    let res = await axios.get(url + '/Web_Online_GetPaymentIvoiceInfo_Json?UserName=' + username + '&Password=' + password + '&fromDate=' + fromdate + '&todate=' + todate);
    var ret: string = res.data.replace('<?xml version="1.0" encoding="utf-8"?>', '');
    var ret2: string = ret.replace('<anyType xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xsi:nil="true" xmlns="http://tempuri.org/" />', '');
    var ret3: string = ret2.replace('<anyType xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:nil="true" xmlns="http://tempuri.org/" />', '');
    var ret4: string = ret3.replace('\r\n', '');
    let result = JSON.parse(ret4);
    // console.log(result);
    return result;
}


const getLabPatients = async (service_url: string, _NowDate: any, _LoginID: any) => {

    let username = "android";
    let password = "diordna";

    if (!service_url.includes("Service1.asmx"))
        service_url = service_url + "/Service1.asmx";

    if (!service_url.includes("http")) {
        service_url = "http://" + service_url;
    }

    // service_url = "http://localhost:8585/Service1.asmx";

    let res = await axios.get(service_url + '/Web_Get_Monitoring?UserName=' + username +
        '&Password=' + password + '&_loginType=3&_SearchValueFrom=' + _NowDate
        + '&_SearchValueTo=' + _NowDate + '&_SearchMode=0&_LoginID=' + _LoginID);

    let ret: string = res.data.replace('<?xml version="1.0" encoding="utf-8"?>\r\n<string xmlns="http://tempuri.org/">', '');
    let ret2: string = ret.replace('</string>', '');
    let result = JSON.parse(ret2);

    return result;

}

const getSepasReport = async (service_url: string, fromDate: string, toDate: string, mode: number, ExportPdf: boolean) => {

    let username = "android";
    let password = "diordna";

    if (!service_url.includes("Service1.asmx"))
        service_url = service_url + "/Service1.asmx";

    if (!service_url.includes("http")) {
        service_url = "http://" + service_url;
    }

    let fromdate = '';
    let todate = '';

    if (fromDate != undefined) {
        fromdate = jalali_moment.from(fromDate, 'fa', 'YYYY/M/D')
            .format('YYYY/M/D');
    }
    if (toDate != undefined) {
        todate = jalali_moment.from(toDate, 'fa', 'YYYY/M/D')
            .format('YYYY/M/D');
    }

    //service_url = "http://192.168.1.20:8586/Service1.asmx";

    let res = await axios.get(service_url + '/Web_LogSendSepas?UserName=' + username +
        '&Password=' + password + '&state=-1&fromDate=' + fromdate
        + '&todate=' + todate + '&Mode=' + mode + '&ExportPdf=' + ExportPdf);

    let ret: string = res.data.replace('<?xml version="1.0" encoding="utf-8"?>\r\n<string xmlns="http://tempuri.org/">', '');
    let ret2: string = ret.replace('</string>', '');
    let result = JSON.parse(ret2);

    return result;

}

const getSpeedTest = async (url: string) => {
    let res = await axios.get(url + '/api/v1/web/WebServer/GetInternetSpeed', checkToken());
    return res;
}

const getParsicSMS = async (requestId: number, url: string) => {
    let res = await axios.get(url + '/api/v1/web/WebServer/WinService?action=' + requestId, checkToken());
    return res;

}

const getVerifyBackup = async (url: string) => {
    //url  = "http://192.168.1.20:8095";
    let res = await axios.get(url + '/api/v1/web/Backup/GetVerifyBackup', checkToken());
    return res;
}

const getVersionHistory = async (fromDate: string, toDate: string, state: number) => {
    let fromdate = '';
    let todate = '';

    if (fromDate != undefined) {
        fromdate = jalali_moment.from(fromDate, 'fa', 'YYYY/M/D')
            .format('YYYY/M/D');
    }
    if (toDate != undefined) {
        todate = jalali_moment.from(toDate, 'fa', 'YYYY/M/D')
            .format('YYYY/M/D');
    }

    let res = await axios.get(apiPath + '/Version/GetVersionHistory?state=0&loginType=' + (state + '&FirstDate=' + fromdate + '&LastDate=' + todate), checkToken());
    return res;
}

const getLastVersion = async () => {

    let res = await axios.get(apiPath + '/Version/GetLastVersion?state=2', checkToken());
    return res;
}
const getVersionRelease = async (status: number) => {

    let res = await axios.get(apiPath + '/Version/GetVersionRelease?paging=50&status=' + status, checkToken());
    return res;
}

const deleteInstallRequestLab = async (id: number) => {
    //var path = "http://192.168.1.20:8074/api"

    let res = await axios.post(apiPath + '/installRequest/Delete',
        {
            id
        }
        , checkToken());

    return res;
}
const UpdateLabInstallRequest = async (id: number, status: number) => {
    //var path = "http://192.168.1.20:8074/api"

    let res = await axios.post(apiPath + '/installRequest/UpdateLabInstallRequest',
        {
            requsetID: id,
            state: status
        }
        , checkToken());

    return res;
}

const getBranchList = async () => {

    let res = await axios.get(apiPath + '/BranchOffice/BranchOffice', checkToken());

    return res;
}

const NewBranchOffice = async (model: any) => {
    let res = await axios.post(apiPath + '/BranchOffice/NewBranchOffice', model, checkToken());
    return res;
}

const getBranchOfficeVUser = async (BranchId: number) => {
    let res = await axios.get(apiPath + '/BranchOffice/BranchOfficeVUser?BranchId=' + BranchId, checkToken());
    return res;
}

const newBranchOfficeVUser = async (model: any) => {
    let res = await axios.post(apiPath + '/BranchOffice/NewBranchOfficeVUser', model, checkToken());
    return res;
}

const getBranchOfficeVState = async (BranchId: number) => {
    let res = await axios.get(apiPath + '/BranchOffice/BranchOfficeVState?BranchId=' + BranchId, checkToken());
    return res;
}

const newBranchOfficeVState = async (model: any) => {
    let res = await axios.post(apiPath + '/BranchOffice/NewBranchOfficeVState', model, checkToken());
    return res;
}

const getPrintReports = async (model: any) => {
    let res = await axios.post(apiPath + '/Report/PrintReport', model, checkToken());
    return res;
}


const isSqlServerAvailable = async (url:string) => {
    let res = await axios.get(url + '/api/v1/web/WebServer/IsSqlServerAvailable', checkToken());
    return res
}

const pingIsAvailable = async (serviceUrl: string) => {
    //serviceUrl = "http://94.182.31.25:8586/";
    const url = new URL(
        serviceUrl.includes('://')
            ? serviceUrl
            : `http://${serviceUrl}`
    );

    const Host = url.hostname.toString();
    let res = await axios.get(apiPath + '/LabTool/PingIsAvailable?Ip=' + Host, checkToken());
    return res;
}

const iisIsAvailable = async (serviceUrl: string) => {

    //serviceUrl = "http://94.182.31.25:8086/";
    const url = new URL(
        serviceUrl.includes('://')
            ? serviceUrl
            : `http://${serviceUrl}`
    );

    const Host = url.hostname;
    const port = url.port
        ? Number(url.port)
        : url.protocol === 'https:'
            ? 443
            : 80;
    let res = await axios.get(apiPath + '/LabTool/IISIsAvailable?Host=' + Host + '&port=' + port, checkToken());
    return res;
}


const getSupportTicketList = async (fromDate: any, toDate: any , labId: number , userId: Number , state: number , searchType: number) => {
    let fDate = '';
    let lDate = '';

    if (fromDate != undefined) {
        fDate = jalali_moment.from(fromDate, 'fa', 'YYYY-M-D')
            .format('YYYY-M-D');
    }
    if (toDate != undefined) {
        lDate = jalali_moment.from(toDate, 'fa', 'YYYY-M-D')
            .format('YYYY-M-D');
    }
    debugger
    let res = await axios.get(apiPath + '/supportTicket/GetSupportTicket2?Frk_labid=' + labId + '&Frk_userId=' + userId + '&FromDate=' + fDate + '&ToDate=' + lDate + '&State=' + state + '&SearchType=' + searchType, checkToken());
    return res;
}

const getLabWhiteList = async () => {
    let res = await axios.get(apiPath + '/LabWhiteList', checkToken());
    return res;
}

const addLabWhiteList = async (frk_LabID : number , frk_ParsicUserId: number , str_IP1: string , str_IP2: string , str_IP3: string , str_IP4: string) => {
    let res = await axios.post(apiPath + `/LabWhiteList/Add` , {
        "frk_LabID": frk_LabID,
        "frk_ParsicUserId": frk_ParsicUserId,
        "str_IP1": str_IP1,
        "str_IP2": str_IP2,
        "str_IP3": str_IP3,
        "str_IP4": str_IP4
    }, checkToken());
    return res;
}

const deleteLabWhiteList = async (prK_LabWhiteList : number) => {
    let res = await axios.post(apiPath + `/LabWhiteList/DELETE` , {
        "prK_LabWhiteList": prK_LabWhiteList,
    }, checkToken());
    return res;
}

const editLabWhiteList = async (wlId: number , frk_LabID : number , frk_ParsicUserId: number , str_IP1: string , str_IP2: string , str_IP3: string , str_IP4: string) => {
    let res = await axios.post(apiPath + `/LabWhiteList/Update` , {
        "prK_LabWhiteList": wlId,
        "frk_LabID": frk_LabID,
        "frk_ParsicUserId": frk_ParsicUserId,
        "str_IP1": str_IP1,
        "str_IP2": str_IP2,
        "str_IP3": str_IP3,
        "str_IP4": str_IP4
    }, checkToken());
    return res;
}

export {
    generateAuthToken, labuserLogin, parsiuserLogin, updateLabUserPassword, forgetPassword, getParsicUser,
    getLabList, generateOTPForNewCustomerRegisteration, newCustomerRegisteration, getState,
    getMachineList, InsertMachineDefination, updateMachineDefination, getMachineNote, InsertMachineNote, getMachineDocumentFile, getAnSpecificMachineDocumentFile, InsertMachineDocumentFile,
    getBankAccount, getOnlinePaymentGateway,
    getMachineInstallRequestList, insertMachineInstallRequestList, getMachineInstallBill, machineInstallManualPay, finilizeMachineInstallRequest, AssignInstallerForMachineInstallRequest, generateOnlineBillLink, billSingularPay, generateSingularBill,
    getFinancialbalance, getlabtaxInfo, updateTaxInfo, uploadpayStatment, getBase64Statement, getBillDetail, getBillType,
    getCableRequestList, completeMakingCable, sendCable, noCableNeed, newCableRequest,
    getSMSrequestBalance, applySMSRequest, getRequestLabSupport
    , getDeliveryType, getDeliveryItems, getDeliveryInstall, getRequestVmachine, getMachineRequest,
    newCenteralInstall, getRequestLabParsicUser, getRequestLabisLabUser
    , getMachineRequestWhithOutConfirm, requestLabFactor, getDeliveryInstallPut
    , getPaymentgetwayRequest, newPaymentgetwayRequest,
    getpaymentgetwayFiles, newPaymentgetwayRequestUpload, updatePaymentgetwayRequest,
    CheckConnection, getLabBackupInfo, getLabBackupLog, getLabSystems, getLabVersions,
    getLabProcess, getLabListWithColumnClass, getGeneralLabInformation, getLabFeedback,
    getProcessName, getClientComputerInformation, ParsXML, getMiscellaneousFunctions, getRemoteAccessList,
    getUsersList, sendMessageToUser, modifyTaxInfo, sendSMS, modifyPayInfo, ExecelTaxInvoiceInfo,
    MakeTaxInvoice, getTaxInfoLabIds, getQuickSearchResult, deleteMachineRequest, getTemperatureRequestList, getTemperatures,
    insertTemperatureInstallRequestList, deleteTempratureRequest, temperatureInstallManualPay, makingTemperature,
    sendingTemperature, getLabTemperatureRequestList, getPadvishRequestList, getLabPadvishRequestList, insertPadvishRequestList,
    padvishRequestFinancialApprove, padvishRequestInstallerApprove, getPadvishRequestLicense, insertPadvishRequestLicense,
    updatePadvishLicenseStatus, padvishLicenseInstallation, padvishLicenseTransfer, getTicketList, getTicketThread, getBaseData,
    getLabReport, sendMessage, getLabInfo, getMessageOfUser, getSMSQueue, convertBase64, convertBase64ToFile, addPaymentgetwayFiles,
    downloadPaymentGetwayAttachments, checkSite, getVoipToken, getVoipList, getPersonnelVoips, getAnonymousCalls,
    getPatientResultReport, getPatientCostReceipt, AssignLab, SendLink, getParsikConfig, sendNewParsinkConfig, getScripts,
    modifyLink, getLabInstallationItems, assignInstaller, getLabInstallerItems, getLabInstallerItemDetails, labInstallationTypeApproveUser,
    labInstallationItemsApproveUser, labInstallationTypeApproveLab, labInstallationItemsApproveLab, getOnlinePaymentReport, getLabPatients,
    getSepasReport, setVoipReports, getVoipReports, getSpeedTest, getParsicSMS, getVerifyBackup, getVersionHistory, getVersionRelease,
    getLastVersion, deleteInstallRequestLab, UpdateLabInstallRequest, getBranchList, NewBranchOffice, getBranchOfficeVUser,
    newBranchOfficeVUser, getBranchOfficeVState, newBranchOfficeVState, getPrintReports, isSqlServerAvailable, pingIsAvailable, iisIsAvailable,
    getSupportTicketList, getLabWhiteList, addLabWhiteList, deleteLabWhiteList, editLabWhiteList
}


